export enum OccupationType {
  Studying = 10,
  Working = 20,
  WorkAndStudy = 30,
  Unemployed = 40,
}
